import React from "react";
import { FILTER_CHIPS } from "../config/sla";

const CaseFilterBar = function (props) {
  const { searchInput, onSearch, chip, onChip } = props;

  return (
    <div className="tn-filterbar">
      <div className="tn-search">
        <svg
          className="tn-search-icon"
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          aria-hidden="true"
        >
          <circle cx="11" cy="11" r="8" />
          <line x1="21" y1="21" x2="16.65" y2="16.65" />
        </svg>
        <input
          type="text"
          className="tn-search-input"
          placeholder="Search reference, customer, serial number…"
          aria-label="Search cases"
          value={searchInput}
          onChange={function (e) {
            onSearch(e.target.value);
          }}
        />
      </div>

      <div className="tn-chips" role="group" aria-label="Case filters">
        {FILTER_CHIPS.map(function (c) {
          const active = c.key === chip;
          return (
            <button
              key={c.key}
              type="button"
              aria-pressed={active}
              className={"tn-chip" + (active ? " tn-chip-active" : "")}
              onClick={function () {
                onChip(c.key);
              }}
            >
              {c.label}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default CaseFilterBar;
